import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class GeolinkMapViewerService {
  constructor(private domSanitizer: DomSanitizer) {}

  getMapViewerHtmlContent(egrid: string, ambiente: string, basemaplayer: string): string {
    return `
      <!DOCTYPE html>
      <html lang="de">
        <head>
          <meta charset="UTF-8">
          <link href="https://webc.geo.ti.ch/siftiweb/static/css/main.d462db52.css" rel="stylesheet">
        </head>
        <body>
          <div id="ti-map-siftiweb"
               basemaplayer="${basemaplayer}"
               egrid="${egrid}"
               ambiente="${ambiente}"
               style="width:100%; height:100%;"></div>
          <script defer src="https://webc.geo.ti.ch/siftiweb/static/js/main.03628842.js"></script>
        </body>
      </html>
    `;
  }

  getMapBlobUrl(htmlContent: string): SafeResourceUrl {
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobUrl: string = URL.createObjectURL(blob);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }
}
